<template>
    <div>
        <HeaderPurchase header="เพิ่มข้อมูลซัพพลายเออร์" :img_header="header_image" link_back="supplier"/>
        <SupplierFrom/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/office-building.png'
    import HeaderPurchase from "@/components/admin/purchase/headerpurchase/HeaderPurchase.vue";
    import SupplierFrom from "@/components/admin/purchase/SupplierFrom";

    export default {
        name: "AddSupplier",
        components: {
            SupplierFrom,
            HeaderPurchase,
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
